import moment from 'moment';

const intervalMinutes = 30;

export const formatPeriod = (start, end) =>
  `${getMomentFromInterval(start).format('HH:mm')} - ${getMomentFromInterval(end).format('HH:mm')}`;

export const getMomentFromInterval = (interval, date) => {
  if (interval >= 0) {
    return moment(date).startOf('day').add(interval * intervalMinutes, 'minutes');
  }
  return null;
};

export const formatPeriodItem = (interval) => {
  const startTime = getMomentFromInterval(interval);
  const endTime = moment(startTime).add(intervalMinutes, 'minutes');
  return `${startTime.format('H:mm')} - ${endTime.format('H:mm')}`;
};

export const sortNumberArray = (a, b) => a - b;
